import React from 'react';
import PropTypes from 'prop-types';
import config from '../../../../../config';
import ConversationList from './ConversationList';

const MemberConversationListManager = ({ conversations, selectConversation, selectedConversation }) => (
  <div className="members flex-fill" style={{ overflowY: 'auto' }}>
    <ConversationList
      id="chat-incoming-list"
      conversationList={conversations.filter(curConversation => curConversation.platform === config.platformsMap.company)}
      contactsNameSpace={config.contactsNameSpaces.members}
      selectConversation={selectConversation}
      selectedConversation={selectedConversation}
    />
  </div>
);

MemberConversationListManager.propTypes = {
  conversations: PropTypes.array.isRequired,
  selectConversation: PropTypes.func.isRequired,
  selectedConversation: PropTypes.object.isRequired,
};

export default MemberConversationListManager;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/chat/chat-components/MemberConversationListManager.jsx